'use client';

import { useEffect, useState } from 'react';

/**
 * Blocks rendering until the MSW service worker is ready.
 *
 * Only rendered in development (see providers.tsx). The worker itself
 * is gated on NEXT_PUBLIC_ENABLE_MOCKS=true — when the flag is unset
 * startMockWorker() resolves immediately and children render without delay.
 */
export function MSWProvider({ children }: { children: React.ReactNode }) {
	const [ready, setReady] = useState(false);

	useEffect(() => {
		if (!ready) {
			startMockWorker()
				.catch((err) => {
					console.error('[MSW] Failed to start mock worker:', err);
				})
				.finally(() => setReady(true));
		}
	}, [ready]);

	if (!ready) return null;

	return children;
}

async function startMockWorker() {
	if (
		process.env.NODE_ENV !== 'development' ||
		process.env.NEXT_PUBLIC_ENABLE_MOCKS !== 'true'
	) {
		return;
	}

	const { worker } = await import('src/mocks/browser');
	await worker.start({ onUnhandledRequest: 'bypass' });
}
